import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_SOFT_ORANGE_BANNER_SX } from "./trackingStyles";

const RequestCustomerActionAlert = ({ tasks, onScrollToForm }) => {
  if (!tasks?.length) return null;

  return (
    <Box
      sx={{
        ...TRACKING_SOFT_ORANGE_BANNER_SX,
        px: { xs: 2, md: 2.5 },
        py: { xs: 1.5, md: 1.75 },
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ flex: 1 }}>
        <WarningAmberRoundedIcon sx={{ fontSize: 22, mt: 0.25 }} />
        <Typography variant="body2" fontWeight={600} lineHeight={1.6}>
          برای ادامه فرآیند، یک اقدام از سمت شما لازم است.
        </Typography>
      </Stack>
      <Button
        variant="contained"
        size="small"
        onClick={onScrollToForm}
        sx={{
          bgcolor: "#F57C00",
          "&:hover": { bgcolor: "#EF6C00" },
          whiteSpace: "nowrap",
          alignSelf: { xs: "stretch", sm: "center" },
          borderRadius: 2,
          fontWeight: 700,
        }}
      >
        مشاهده اقدامات
      </Button>
    </Box>
  );
};

RequestCustomerActionAlert.propTypes = {
  tasks: PropTypes.array,
  onScrollToForm: PropTypes.func,
};

export default RequestCustomerActionAlert;
